import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function ClientRedirect({ targetUrl }) {
  const navigate = useNavigate();

  useEffect(() => {
    if (targetUrl) {
      // Open external page in new tab
      window.open(targetUrl, "_blank", "noopener,noreferrer");
      // Optional: redirect back to home or some safe page after opening
      navigate("/"); 
    }
  }, [targetUrl, navigate]);

  return null; // renders nothing
}
